import React from "react";
import "./buttonAddHL.css";


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 * @description Layout of button that allows user to add new elements to the flow of a3 framework. Examples include: Agregar Nueva Empresas, 
 * Agregar dominio, etc.
 */
const ButtonAddHLPure = (props) => {
  const {
    nameBtn, //Text in btn
    onClickBtn, //Function onClick button
    iconAdd, // True to use plus icon and false to custom icon
    customIcon, //Choose a icon
    disabled, //True to disabled button, false not disabled
  } = props;

  return (
    <button
      disabled={disabled}
      className="buttonAddHLPure-add"
      onClick={onClickBtn ? onClickBtn : props.onClick}
      {...props}
    >
      {iconAdd ? (
        <i className={"k-icon k-i-plus buttonAddHLPure-iconPlus-Style"}></i>
      ) : (
        <img src={customIcon} className="buttonAddHLPure-customIcon" />
      )}

      <span className="buttonAddHLPure-label">
        {nameBtn}
      </span>
    </button>
  );
};

export { ButtonAddHLPure as default };
